export default function hash() {
    let path = window.location.hash;
    let pathName = '';
    let query = '';
    if (path.charAt(0) === '#') path = path.slice(1);
    pathName = path;
    const questionMarkIndex = path.indexOf('?');
    if (questionMarkIndex > -1) {
        pathName = path.slice(0, questionMarkIndex);
        query = path.slice(questionMarkIndex);
    }
    if (pathName === '/') pathName = '/myvideo';
    if (query) return pathName + query;
    return pathName;
}



// WEBPACK FOOTER //
// ./client/util/repushhash.js